export default __webpack_public_path__ + "static/media/arab.123db3f5.png";